import { Component } from "@angular/core";
import { AuthService } from "src/app/services/auth/auth.service";
import { StyleService } from "src/app/services/style/style.service";

@Component({
    selector: "app-register-completed",
    templateUrl: "./register-completed.component.html",
    styleUrls: [ "./register-completed.component.scss" ]
})
export class RegisterCompletedComponent {
    protected readonly logoUrl: string;
    protected readonly brandName: string;

    public constructor(authService: AuthService, styleService: StyleService) {
        this.brandName = authService.getTenantName();
        this.logoUrl = styleService.getLogoUrl();
    }
}
